/* eslint-disable */

export const getShortUrl = /* GraphQL */ `
  query GetShortUrl($longUrl: String!) {
    getShortUrl(longUrl: $longUrl) {
      id
      created_at
      link
      long_url
    }
  }
`
export const sendEmail = /* GraphQL */ `
  query SendEmail($to: String!, $subject: String!, $content: String!, $replyTo: String) {
    sendEmail(to: $to, subject: $subject, content: $content, replyTo: $replyTo) {
      response
    }
  }
`
export const getAssociation = /* GraphQL */ `
  query GetAssociation($id: ID!) {
    getAssociation(id: $id) {
      id
      name
      address
      city
      state
      postalCode
      country
      cardId
      email
      image {
        bucket
        region
        key
      }
      location
      phone
      url
      createdAt
      updatedAt
    }
  }
`
export const listAssociationsUserss = /* GraphQL */ `
  query ListAssociationsUserss(
    $filter: ModelAssociationsUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssociationsUserss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        unit
        role
        title
        association {
          id
          name
        }
        user {
          id
          firstName
          lastName
          email
          phone
          avatar {
            bucket
            region
            key
          }
          createdAt
        }
        createdAt
      }
    }
  }
`
export const getBetaCode = /* GraphQL */ `
  query GetBetaCode($id: ID!) {
    getBetaCode(id: $id) {
      id
      createdAt
      updatedAt
    }
  }
`
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      email
      phone
      avatar {
        bucket
        region
        key
      }
      associations {
        items {
          id
          unit
          role
          title
          createdAt
          association {
            id
            name
            url
            address
            location
            email
            phone
            createdAt
          }
        }
        nextToken
      }
      createdAt
    }
  }
`

export const listUsers = /* GraphQL */ `
  query ListUsers($filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
        createdAt
      }
      nextToken
    }
  }
`

export const getDocument = /* GraphQL */ `
  query GetDocument($associationId: String!, $type: DocumentType!, $createdAt: AWSDateTime!) {
    getDocument(associationId: $associationId, type: $type, createdAt: $createdAt) {
      id
      title
      content
      files {
        items {
          id
          file {
            bucket
            region
            key
          }
          title
          createdAt
        }
        nextToken
      }
      type
      createdAt
      updatedAt
    }
  }
`
export const listDocuments = /* GraphQL */ `
  query ListDocuments(
    $associationId: String
    $typeCreatedAt: ModelDocumentPrimaryCompositeKeyConditionInput
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDocuments(
      associationId: $associationId
      typeCreatedAt: $typeCreatedAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          items {
            id
            file {
              bucket
              region
              key
            }
            title
            createdAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`
export const getShare = /* GraphQL */ `
  query GetShare($id: ID!) {
    getShare(id: $id) {
      id
      associationId
      email
      content
      types
      createdAt
      updatedAt
    }
  }
`
export const listShares = /* GraphQL */ `
  query ListShares($filter: ModelShareFilterInput, $limit: Int, $nextToken: String) {
    listShares(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        associationId
        email
        content
        types
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`
export const getInvite = /* GraphQL */ `
  query GetInvite($id: ID!) {
    getInvite(id: $id) {
      id
      email
      role
      createdAt
      association {
        id
        name
      }
    }
  }
`
export const listInvites = /* GraphQL */ `
  query ListInvites($filter: ModelInviteFilterInput, $limit: Int, $nextToken: String) {
    listInvites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        role
        author {
          id
          firstName
          lastName
          email
          phone
          avatar {
            bucket
            region
            key
          }
          createdAt
        }
        createdAt
        association {
          id
          name
        }
      }
      nextToken
    }
  }
`
export const getMessage = /* GraphQL */ `
  query GetMessage($associationId: String!, $createdAt: AWSDateTime!) {
    getMessage(associationId: $associationId, createdAt: $createdAt) {
      id
      associationId
      content
      createdAt
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
      }
      updatedAt
      owner
      files {
        items {
          id
          file {
            bucket
            region
            key
          }
          createdAt
        }
        nextToken
      }
    }
  }
`
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $associationId: String
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMessages(
      associationId: $associationId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        associationId
        content
        createdAt
        author {
          id
          firstName
          lastName
          email
          phone
          avatar {
            bucket
            region
            key
          }
        }
        updatedAt
        owner
      }
      nextToken
    }
  }
`
export const getFile = /* GraphQL */ `
  query GetFile($id: ID!) {
    getFile(id: $id) {
      id
      associationId
      file {
        bucket
        region
        key
      }
      parentId
      title
      createdAt
      updatedAt
      owner
    }
  }
`
export const listFiles = /* GraphQL */ `
  query ListFiles($filter: ModelFileFilterInput, $limit: Int, $nextToken: String) {
    listFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        associationId
        file {
          bucket
          region
          key
        }
        parentId
        title
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`
export const getDisclosure = /* GraphQL */ `
  query GetDisclosure($id: ID!, $associationId: String!) {
    getDisclosure(id: $id, associationId: $associationId) {
      id
      associationId
      createdAt
      unit
      haveLiens
      liensDescription
      reservesAmount
      haveCapitalExpenditures
      capitalExpendituresType
      capitalExpendituresOther
      haveSpecialAssessment
      specialAssessmentAmount
      haveIncreaseMonthly
      increaseMonthlyAmount
      increaseMonthlyEndDate
      haveCompliantAlterations
      compliantAlterationsDescription
      haveLawsuits
      lawsuitsDescription
      insuranceName
      insuranceAddress
      insuranceContactName
      insurancePhone
      insuranceEmail
      asssessmentAmount
      unpaidAssessmentAmount
      contactEmail
      preparedByName
      preparedDate
      sent
      updatedAt
      latestFinancials {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestBudget {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestMinutes {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      owner
    }
  }
`
export const listDisclosures = /* GraphQL */ `
  query ListDisclosures(
    $id: ID
    $associationId: ModelStringKeyConditionInput
    $filter: ModelDisclosureFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDisclosures(
      id: $id
      associationId: $associationId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        associationId
        createdAt
        unit
        haveLiens
        liensDescription
        reservesAmount
        haveCapitalExpenditures
        capitalExpendituresType
        capitalExpendituresOther
        haveSpecialAssessment
        specialAssessmentAmount
        haveIncreaseMonthly
        increaseMonthlyAmount
        increaseMonthlyEndDate
        haveCompliantAlterations
        compliantAlterationsDescription
        haveLawsuits
        lawsuitsDescription
        insuranceName
        insuranceAddress
        insuranceContactName
        insurancePhone
        insuranceEmail
        asssessmentAmount
        unpaidAssessmentAmount
        contactEmail
        preparedByName
        preparedDate
        sent
        updatedAt
        latestFinancials {
          id
          associationId
          title
          content
          type
          createdAt
          updatedAt
          owner
        }
        latestBudget {
          id
          associationId
          title
          content
          type
          createdAt
          updatedAt
          owner
        }
        latestMinutes {
          id
          associationId
          title
          content
          type
          createdAt
          updatedAt
          owner
        }
        owner
      }
      nextToken
    }
  }
`
export const itemsByAssociationDate = /* GraphQL */ `
  query ItemsByAssociationDate(
    $associationId: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDisclosureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByAssociationDate(
      associationId: $associationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        associationId
        createdAt
        unit
        haveLiens
        liensDescription
        reservesAmount
        haveCapitalExpenditures
        capitalExpendituresType
        capitalExpendituresOther
        haveSpecialAssessment
        specialAssessmentAmount
        haveIncreaseMonthly
        increaseMonthlyAmount
        increaseMonthlyEndDate
        haveCompliantAlterations
        compliantAlterationsDescription
        haveLawsuits
        lawsuitsDescription
        insuranceName
        insuranceAddress
        insuranceContactName
        insurancePhone
        insuranceEmail
        asssessmentAmount
        unpaidAssessmentAmount
        contactEmail
        preparedByName
        preparedDate
        sent
        updatedAt
        latestFinancials {
          id
          associationId
          title
          content
          type
          createdAt
          updatedAt
          owner
        }
        latestBudget {
          id
          associationId
          title
          content
          type
          createdAt
          updatedAt
          owner
        }
        latestMinutes {
          id
          associationId
          title
          content
          type
          createdAt
          updatedAt
          owner
        }
        owner
      }
      nextToken
    }
  }
`
